'use strict';

const React = require('react');
const PropTypes = require('prop-types');

class ImgPortrait extends React.Component {

    onSelect=()=>{
        if (this.props.onSelect) {
            this.props.onSelect();
        };
    }

    onClose=()=>{
        if (this.props.onClose) {
            this.props.onClose();
        };
    }
    
    doKeyboard=(e)=>{
        // We're not checking space here because it (apparently) is used by scroll areas 
        if (e.key == 'Enter') {
            this.onSelect();
        }
        else if (e.keyCode == 27) { // escape
            this.onClose();
        }

        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
        }
    }
    
    render() {
        var portraitID = this.props.portraitID;
        var imgPath, imgDesc;
        if (this.props.imageSrc) {
            imgPath = this.props.imageSrc.replace(/^\$ASSET_PREFIX/, GlobalConfig.AssetStoreUrl);
            imgDesc = this.props.imageDesc;
        }
        else {
            let avatarEntry = MZLAvatarLibrary.getAvatar(portraitID) || MZLAvatarLibrary.getDefaultAvatar();
            imgPath = avatarEntry.src;
            imgDesc = avatarEntry.altText;
        }
        
        var role = this.props.onSelect && !this.props.decorative ? "button": "presentation";
        if (this.props.role) {
            role = this.props.role;
        }
        var tabIdx = this.props.onSelect ? 0 : -1;
        if (typeof this.props.tabIndex !== 'undefined') {
            tabIdx = this.props.tabIndex;
        }
        var selected = false;
        if (role === "radio") {
            selected = this.props.selected;
        }
        if (this.props.decorative) {
            imgDesc = "";
            selected = null;
        } else if (!imgDesc) {
            imgDesc = "Generic Avatar";
        }
        return (<img ref="img" id={this.props.id} className={this.props.imgClass} tabIndex={tabIdx} role={role} aria-checked={selected} src={imgPath} onClick={this.onSelect} onKeyDown={this.doKeyboard} alt={imgDesc}/>);
    }
}; // ImgPortrait

ImgPortrait.propTypes = {
    portraitID:     PropTypes.string,
    imageSrc:       PropTypes.string,
    onSelect:       PropTypes.func,
    onClose:        PropTypes.func,
    onKeyDown:      PropTypes.func,
    focusOnMount:   PropTypes.bool,
    imgClass:       PropTypes.string,
    tabIndex:       PropTypes.number,
    id:             PropTypes.string,
    decorative:     PropTypes.bool,
    role:           PropTypes.string,
    selected:       PropTypes.bool
};

module.exports = ImgPortrait;

